// Remove commas
export const unformatNumber = (val) => val.replace(/,/g, "");

// Format with Indian comma style (lakh format)
export const formatCTC = (val) => {
  if (!val) return "";

  const num = val.toString().replace(/,/g, "");

  return new Intl.NumberFormat("en-IN").format(num);
};